"use client";

import * as React from "react";
import { getBrandConfig } from "@/lib/branding";

export function BrandTitleEffect() {
  React.useEffect(() => {
    const apply = () => {
      const brand = getBrandConfig();
      document.title = brand.appTitle;
    };

    apply();
  }, []);

  return null;
}
